import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'

export default ({ path }) => {
    return (
        <div className={baseStyles.root}>
            <h2>Guide de l’étudiant·e</h2>
            <PageStatus path={path} />
            <p>
                Consulter dès maintenant le {' '}
                <a href="https://heig.ch/guide-etudiant" target="_blank" rel="noopener noreferrer">
                    Guide de l'étudiant·e
                </a>
              {' '} qui réunit toutes les informations essentielles pour préparer votre arrivée à la HEIG-VD.
            </p>
        </div>
    )
}
